import Vue from 'vue';
//import { EventBus } from '../../utils/event-bus';

export const internetConnection = async () => {
  if (Vue.router.history.current.name !== 'live-discussion.discussion') {
    return;
  }
  const xhr = new XMLHttpRequest();
  const file = "https://i.imgur.com/7ofBNix.png";
  const randomNum = Math.round(Math.random() * 10000);
  xhr.open('HEAD', file + "?rand=" + randomNum, true);
  xhr.send();
  xhr.onreadystatechange = function () {
    if (xhr.readyState === 4) {
      if (xhr.status === 200) {
        const { lost_connection } = Vue.router.history.current.query;
        if (lost_connection === true) {
          window.location.reload();
          Vue.router.replace({ query: {} });
        }
        return { current: 'connected' };
      }
      // const toast = { type: 'Error', message: "You're lost connection internet", time: 5000 };
      // EventBus.$emit('createToast', toast);
      Vue.router.replace({ query: { lost_connection: true } });
    }
  };
};


// WEBPACK FOOTER //
// ./src/app/features/liveDiscussion/internetConnection.js